import { Routes, Route } from "react-router-dom";

import {
  AddNewAgent,
  ChoiceMerchant,
  ContactInfo,
  EditAgent,
  EmployeeDetail,
  FaqDetails,
  FaqList,
  IntegratorInfoUpdate,
  Otp,
  WorkingConditions,
} from "components";

import ProtectedRouter from "./ProtectedRouter";
import {
  Dashboard,
  EmployeeScreen,
  Homescreen,
  LoginScreen,
  PasswordScreen,
  ProfileScreen,
} from "pages";
import NotFoundScreen from "pages/NotFound/NotFoundScreen";
import FirstPasswordChange from "components/Auth/Password/FirstPasswordChange";
import FirstPasswordChangeAdmin from "components/Auth/Password/FirstPasswordChangeAdmin";
import AdminSecurityPhotoChange from "components/Auth/Password/AdminSecurityPhotoChange";

const Router = () => {
  return (
    <>
      <Routes>
        <Route element={<Homescreen />}>
          <Route element={<ProtectedRouter />}>
            <Route path='/' index element={<Dashboard />} />
            <Route path='/choice-merchant' element={<ChoiceMerchant />} />
            <Route
              path='/my-profile/:merchantName'
              element={<ProfileScreen />}
            />
            <Route path='/integrator' element={<IntegratorInfoUpdate />} />
            <Route path='/employee-panel' element={<EmployeeScreen />} />
            <Route path='/add-newAgent' element={<AddNewAgent />} />
            <Route
              path='/edit-agent/:name/:phoneNumber'
              element={<EditAgent />}
            />
            <Route
              path='/employee-detail/:name/:phoneNumber/:status'
              element={<EmployeeDetail />}
            />
            <Route path='/contact-info' element={<ContactInfo />} />
            <Route path='/working-conditions' element={<WorkingConditions />} />
            <Route path='/faq-list' element={<FaqList />} />
            <Route path='/faq-details/:faqId' element={<FaqDetails />} />
          </Route>
          <Route path='/login' element={<LoginScreen />} />
          <Route path='/otp' element={<Otp />} />
          <Route path='/get-password' element={<PasswordScreen />} />
          <Route path='/get-password-first' element={<FirstPasswordChange />} />
          <Route
            path='/get-password-first-admin'
            element={<FirstPasswordChangeAdmin />}
          />
          <Route
            path='/admin-security-photo'
            element={<AdminSecurityPhotoChange />}
          />
          <Route path='*' element={<NotFoundScreen />} />
        </Route>
      </Routes>
    </>
  );
};

export default Router;
